
export const PriceDetailsCard = () => {

    return (
        <div className={` w-[35%] p-3 bg-white h-max rounded-md space-y-3`}>
            <div className="text-sm text-black font-semibold border-b py-2">
                Price Details
            </div>
            <div className="w-full space-y-3 border-b py-2">
                <div className="flex items-center justify-between">
                    <span className="text-sm font-semibold">Total Price</span>
                    <span className="text-sm font-medium">$399.80</span>
                </div>

                <div className="flex items-center justify-between">
                    <span className="text-sm font-semibold">Discount</span>
                    <span className="text-sm font-medium text-primary">-$20</span>
                </div>

            </div>
            <div className="flex items-center justify-between">
                <span className="text-sm font-bold">Total</span>
                <span className="text-sm font-medium">$379.80</span>
            </div>
            <button className="w-full bg-primary hover:bg-orange-600 text-white text-sm py-3 px-8 rounded-[70px] font-medium transition">
                Go to Checkout
            </button>

        </div>
    )
}